import { render, staticRenderFns } from "./Home3.vue?vue&type=template&id=2a5bd9d6"
import script from "./Home3.vue?vue&type=script&lang=js"
export * from "./Home3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports